import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { storageService } from '@core/js/services/storage.service';
import { LAYER } from '@theme/js/components/common/PopupManager';
import { showCommonPopupAction } from '@core/js/components/common/popups/CommonPopup';

import * as constants from './constants';

export const useGDPRPopup = () => {
    const dispatch = useDispatch();
    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);

    const hideGDPR = searchParams.get('hideGdpr');

    useEffect(() => {
        if (hideGDPR === '1' || storageService.local.getItem(constants.GDPR_POPUP) === 'true'
            || storageService.local.getItem(constants.GDPR_POPUP_VISIBLE) === 'true') {
            return;
        }

        dispatch(showCommonPopupAction({
            layer: LAYER.GDPRP,
            className: 'GDPR-popup',
            title: 'playtech.mobile.system.gdrp-popup.title',
            articleId: constants.ARTICLE_ID,
            btnTitle: 'playtech.mobile.system.gdrp-popup.accept',
            onClose: () => storageService.local.setItem(constants.GDPR_POPUP, 'true'),
            isModal: true
        }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
